(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mobile-app-header"] && !Shopify.designMode) return;
  try {
    
  // Mobile Menu Toggle
  const menuToggle = document.querySelector('[data-mobile-menu]');
  const menuDrawer = document.querySelector('[data-mobile-drawer]');
  const menuOverlay = document.querySelector('[data-mobile-overlay]');
  const menuClose = document.querySelector('[data-mobile-close]');

  function openMenu() {
    menuDrawer.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    menuDrawer.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (menuToggle) {
    menuToggle.addEventListener('click', openMenu);
  }

  if (menuOverlay) {
    menuOverlay.addEventListener('click', closeMenu);
  }

  if (menuClose) {
    menuClose.addEventListener('click', closeMenu);
  }

  } catch(e) { console.error(e); }
})();
})();
